import CourseAside, { generateSocialSharingURLs } from './course-aside';

export { generateSocialSharingURLs };
export default CourseAside;
